import { valuesActionTypes } from './values';

const HYDRATE_APPLIED_FILTERS = 'HYDRATE_APPLIED_FILTERS';
const SET_FILTER_VISIBILITY = 'SET_FILTER_VISIBILITY';
const SET_APPLIED_FILTERS = 'SET_APPLIED_FILTERS';
const RESET_APPLIED_FILTERS = 'RESET_APPLIED_FILTERS';

export default {
    HYDRATE_APPLIED_FILTERS,
    SET_FILTER_VISIBILITY,
    SET_APPLIED_FILTERS,
    RESET_APPLIED_FILTERS,
    ...valuesActionTypes,
};
